// extracted by mini-css-extract-plugin
module.exports = {"root":"realWeddingPage_root__yUDZS"};